import ReactModal from "react-modal";
import Avatar from "react-avatar-edit";
import React, { useRef, useState } from 'react'
import TermsAndConditions from "./TermsAndConditions";
import useIsMobile from "Hooks/useIsMobile";

function TermsAndCondModal({uploadNew, onClose, onSubmit, onDecline}) {
    const scrollRef = useRef(null);
    const isMobile = useIsMobile();
    const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

    const handleScroll = () => {
      const element = scrollRef.current;
      if (element) {
        const isAtBottom =
          element.scrollTop + element.clientHeight >= element.scrollHeight - 2;
        setIsScrolledToBottom(isAtBottom);
      }
    };
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30,
          backgroundColor: 'rgba(20,33,61,.55)'
        },
        content: {
            height: isMobile ? '80vh' : '500px',
            width: isMobile ? '90vw' : '680px',
            overflow: 'hidden',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '0',
            transform: 'translate(-50%, -50%)',
            padding: 0,
            border: '1px solid rgba(20,33,61,.14)',
            borderRadius: '4px',
            backgroundColor: '#fffdf8',
        }
      }}
    >

        <div className="w-full h-full flex items-center justify-center font-plexsans">
        <div className="w-full h-full mx-auto px-5 py-7 lg:px-9 lg:py-9 text-navy flex flex-col">
    <h1 className="font-spectral font-normal text-navy text-[22px] lg:text-[26px] mb-5 flex-none">Terms and Conditions</h1>
    <div
     ref={scrollRef}
     onScroll={handleScroll}
     className="flex-1 min-h-0 overflow-y-auto text-navy/70 p-4 pb-20 border border-navy/[0.14] bg-cream rounded-sm"
     >
       <TermsAndConditions/>
          </div>
          </div>

            <div className="absolute bottom-0 left-0 right-0 p-4 flex justify-end bg-ivory border-t border-navy/10">
          <div
            className={`text-[13.5px] lg:text-[14px] font-plexsans font-medium py-2.5 px-4 mr-2 rounded-sm mt-2 flex justify-center items-center transition-colors ${
              isScrolledToBottom
                ? "bg-tan hover:bg-tanDark text-ivory cursor-pointer"
                : "bg-navy/10 text-navy/40 cursor-not-allowed"
            }`}
            onClick={() => isScrolledToBottom && onSubmit()}
          >
            Accept
          </div>
          <div
            className="text-[13.5px] lg:text-[14px] font-plexsans font-medium py-2.5 px-4 rounded-sm mt-2 bg-transparent border border-navy/20 hover:bg-navy/5 text-navy flex justify-center items-center cursor-pointer"
            onClick={onDecline}
          >
            Decline
          </div>
        </div>

        </div>
    </ReactModal>
  )
}

export default TermsAndCondModal
